module.exports = __webpack_public_path__ + "static/media/icon-days.8e307fe8.svg";